import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/banner5-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";

import "./SocietyNewsPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";

const SocietyNewsPage = () => {
  const { t } = useTranslation();

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://www.hkarbsoc.org.hk:9003/api/posts/");
        console.log(response.data);
        setBlogs(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("society_news_page_header")}</h1>
          <p className="banner-subtitle">{t("society_news_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_society_news_page_link1")}</Link>
        <span>{t("breadcrumbs_society_news_page_span")}</span>
        <Link>{t("breadcrumbs_society_news_page_link2")}</Link>
      </Breadcrumbs>

      <main className="society-news-main-container">
        <section className="society-news-content-section">
          { blogs.length > 0 && blogs.map((blog, index) => (
              <Link to={`/societynewsdetail/${blog?._id}`} key={index} className="news-item-link">
                <article className="news-item">
                  <div className="news-image-container">
                    <img src={`${blog?.featuredImage}`} alt={blog?.title} className="news-image" />
                  </div>
                  <div className="news-content">
                    <h4 className="news-title">{t(blog?.title ? blog.title : "")}</h4>
                    <span className="news-date">
                      {blog?.createdAt ? new Date(blog.createdAt ? blog.createdAt : "").toLocaleDateString() : ""}
                    </span>
                    <p
                      className="news-description"
                      dangerouslySetInnerHTML={{ __html: blog?.shortDescription || "" }}
                    />
                  </div>
                </article>
              </Link>
            ))}
        </section>
      </main>

      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>
      <Footer />
    </>
  );
};

export default SocietyNewsPage;
